/* ==========================================================================
   SPRYNT - community pop-up (10% korting op de eerste bestelling)
   --------------------------------------------------------------------------
   De pop-up zelf staat in snippets/sprynt-newsletter-popup.liquid en gebruikt
   het echte Shopify-inschrijfformulier. Dit bestand regelt alleen wanneer hij
   verschijnt, het sluiten en het scherm na een geslaagde inschrijving.

   WANNEER HIJ VERSCHIJNT (4 seconden na het laden):
   - Bij de eerste pagina van een bezoek.
   - Bij een echte verversing (F5 / Ctrl+R) van de pagina.
   NIET bij het doorklikken naar een andere pagina binnen de shop, en niet meer
   nadat iemand zich dat bezoek heeft ingeschreven.

   - Wie al lid is en ingelogd, krijgt de melding dat hij al deelneemt.
   - De kortingscode staat in het liquid-bestand, niet hier.
   - Testen: ?sprynt-popup=1 forceert hem meteen, zonder wachten.
   ========================================================================== */

(function () {
  'use strict';

  var DELAY_MS = 4000;
  var KEY_DONE = 'sprynt:nb-done';
  var KEY_SHOWN = 'sprynt:nb-shown';

  var params = new URLSearchParams(window.location.search);
  var mode = params.get('sprynt-popup');
  var forced = mode === '1' || mode === 'reset';
  var posted = params.get('customer_posted') === 'true';
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  var root = null;
  var lastFocus = null;

  function flag(key) {
    try {
      return sessionStorage.getItem(key) === '1';
    } catch (e) {
      return false;
    }
  }

  function setFlag(key) {
    try {
      sessionStorage.setItem(key, '1');
    } catch (e) {}
  }

  if (mode === 'reset') {
    try {
      sessionStorage.removeItem(KEY_DONE);
      sessionStorage.removeItem(KEY_SHOWN);
      localStorage.removeItem('sprynt:nb-subscribed');
      localStorage.removeItem('sprynt:nb-dismissed-until');
      localStorage.removeItem('sprynt:nb3-subscribed');
      localStorage.removeItem('sprynt:nb3-dismissed-until');
    } catch (e) {}
  }

  // Is deze paginaweergave een echte verversing, of kwam de bezoeker via een link?
  function isReload() {
    try {
      var entries = performance.getEntriesByType('navigation');
      if (entries && entries.length) return entries[0].type === 'reload';
      if (performance.navigation) return performance.navigation.type === 1;
    } catch (e) {}
    return false;
  }

  function focusable() {
    return Array.prototype.filter.call(
      root.querySelectorAll('button, input, a[href]'),
      function (el) { return el.offsetParent !== null; }
    );
  }

  function trap(event) {
    var items = focusable();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function open() {
    if (!root || !root.hidden) return;
    lastFocus = document.activeElement;
    root.hidden = false;
    document.body.style.overflow = 'hidden';
    setFlag(KEY_SHOWN);
    var input = root.querySelector('.sp-nb__input');
    if (input && !input.closest('[hidden]') && window.matchMedia('(min-width: 750px)').matches) {
      input.focus();
    }
  }

  function close() {
    if (!root || root.hidden) return;
    root.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function copyCode(button) {
    var holder = root.querySelector('.sp-nb__code');
    var code = holder ? holder.textContent.trim() : '';
    if (!code) return;
    var done = function () {
      button.textContent = 'Gekopieerd';
      window.setTimeout(function () { button.textContent = 'Code kopiëren'; }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, function () {});
    }
  }

  function showStep(name) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-step]'), function (step) {
      step.hidden = step.getAttribute('data-step') !== name;
    });
  }

  function onSubmit(event) {
    var form = event.currentTarget;
    var input = form.querySelector('.sp-nb__input');
    var error = root.querySelector('[data-error]');
    var email = (input.value || '').trim();

    if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email)) {
      event.preventDefault();
      error.textContent = 'Vul een geldig e-mailadres in.';
      error.hidden = false;
      input.focus();
      return;
    }

    var button = form.querySelector('.sp-nb__btn');
    if (button) {
      button.disabled = true;
      button.textContent = 'Even geduld...';
    }
  }

  function init() {
    root = document.getElementById('sprynt-newsletter-popup');
    if (!root) {
      if (forced) console.warn('SPRYNT: pop-up niet gevonden in de pagina.');
      return;
    }

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-close]')) close();
      var copy = event.target.closest('[data-copy]');
      if (copy) copyCode(copy);
    });

    var form = root.querySelector('form');
    if (form) form.addEventListener('submit', onSubmit);

    document.addEventListener('keydown', function (event) {
      if (root.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'Tab') trap(event);
    });

    // Net ingeschreven: toon de kortingscode en laat hem dit bezoek verder met rust.
    if (posted) {
      setFlag(KEY_DONE);
      showStep('done');
      open();
      return;
    }

    // Shopify gaf een foutmelding terug op het formulier.
    if (root.querySelector('[data-server-error]')) {
      open();
      return;
    }

    if (forced) {
      open();
      return;
    }

    // Dit bezoek al ingeschreven: niet opnieuw vragen.
    if (flag(KEY_DONE)) return;

    // Alleen bij de eerste pagina van het bezoek of bij een echte verversing.
    // Doorklikken naar een andere pagina laat hem met rust.
    if (flag(KEY_SHOWN) && !isReload()) return;

    window.setTimeout(function () { open(); }, designMode ? 1200 : DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
